import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { Configuration } from "./utils/configuration";
import { authTokenRef } from "./store/AuthProvider";

const httpLink = createHttpLink({
  uri: Configuration.apiUrl,
});

const authLink = setContext((_, { headers }) => {
  // Read the current access token published by the active IdP provider
  // (Okta or Entra). Read at request time so token refreshes are picked up.
  const token = authTokenRef.current;
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
